// extracted by mini-css-extract-plugin
module.exports = {"header":"ShareAction_header__1gWXd"};